import React, { ChangeEvent } from 'react';
import LcToolTip from '../../Generic/LcTooltip';

//CSS
import './index.css';

interface InputProps {
    label?: string,
    toolTip?: boolean,
    toolTipText?: string,
    name?: string,
    value?: string | number,
    required?: boolean,
    type: string,
    placeHolder?: string,
    icon?: string,
    pattern?: string,
    onChange?: Function,
    width?: string,
    disableAutocomplete?: boolean,
    readonly?: boolean,
    disable?: boolean
    className?: string,
    max?: string,
    ref?: any,
    updateParentConst?: boolean
}

export const InputField: React.FC<InputProps> = (props) => {

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const { name, value } = event.target;
        props.onChange && props.onChange({ name, value });
    }

    return (
        <div className={`lc-input ${props.icon && 'icon'}`} style={{ width: props.width }}>
            {props.label &&
                <div className="Grid" style={{ marginBottom: '0.6rem' }}>
                    <span className="label">{props.label}</span>
                    {props.toolTip && <LcToolTip trigger="hover" content={props.toolTipText} position="center"><i className="ppi ppi-exclamation-circle"></i></LcToolTip>}
                </div>}
            <div className={`field ${props.icon ? 'icon' : ''}`}>
                {props.icon && <i className={props.icon}></i>}
                {props.updateParentConst 
                    ? 
                        <input 
                            required={props.required} 
                            className={props.className} 
                            disabled={props.disable} 
                            readOnly={props.readonly} 
                            name={props.name} 
                            defaultValue={props.value} 
                            type={props.type} 
                            placeholder={props.placeHolder || ''} 
                            onChange={handleChange} 
                            autoComplete={props.disableAutocomplete ? 'off' : 'on'} 
                            list={props.disableAutocomplete ? 'autocompleteOff' : ''} 
                            max={props.max} 
                            value={props.value} />
                    : 
                        <input 
                            required={props.required} 
                            className={props.className} 
                            disabled={props.disable} 
                            readOnly={props.readonly} 
                            name={props.name} 
                            defaultValue={props.value} 
                            type={props.type} 
                            placeholder={props.placeHolder || ''} 
                            onChange={handleChange} 
                            autoComplete={props.disableAutocomplete ? 'off' : 'on'} 
                            list={props.disableAutocomplete ? 'autocompleteOff' : ''} 
                            max={props.max} />
                }
            </div>
        </div>
    );
}

export const FileField: React.FC<InputProps> = (props) => {

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const files = event.target.files;
        props.onChange && props.onChange(files);
    }

    return (
        <div className={`lc-input ${props.icon && 'icon'}`} style={{ width: props.width }}>
            <span className="label">{props.label}</span>
            {
                props.icon && <i className={props.icon} />
            }
            <input 
                name={props.name} 
                defaultValue={props.value} 
                type="file" 
                placeholder={props.placeHolder || ''} 
                onChange={handleChange} />
        </div>
    );
}

interface InputTextAreaProps {
    label: string,
    name: string,
    value?: string,
    rows: number,
    placeHolder?: string,
    icon?: string,
    onChange?: Function,
    width?: string,
    ref?: any,
    required?: boolean
}

export const TextAreaField: React.FC<InputTextAreaProps> = (props) => {

    function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
        const { name, value } = event.target;
        props.onChange && props.onChange({ name, value });
    }

    return (
        <div className={`lc-input ${props.icon && 'icon'}`} style={{ width: props.width }}>
            <span className="label">{props.label}</span>
            {props.icon && <i className={props.icon}></i>}
            <textarea 
                required={props.required} 
                ref={props.ref ?? props.ref} 
                name={props.name} 
                defaultValue={props.value} 
                placeholder={props.placeHolder || ''} 
                rows={props.rows} 
                style={{ width: props.width }}
                onChange={handleChange} />
        </div>
    );
}

interface SelectProps {
    label?: string,
    name: string,
    options?: { value: string, name: string }[],
    value?: string,
    values?: string[],
    placeHolder?: string,
    onChange?: Function,
    width?: string,
    ref?: any,
    className?: string,
    multiple?: boolean,
    required?: boolean
}

export const SelectField: React.FC<SelectProps> = (props) => {

    function handleChange(event: ChangeEvent<HTMLSelectElement>) {
        const { name, value } = event.target;
        props.onChange && props.onChange({ name, value });
    }

    function handleMultiChange(event: ChangeEvent<HTMLSelectElement>) {
        const array = Array.from(event.target.selectedOptions, option => option.value);
        props.onChange && props.onChange(array);
    }

    return (
        <div className={`lc-input`} style={{ width: props.width }}>
            {props.label && <span className="label">{props.label}</span>}
            <div className={`field ${props.multiple ? 'multi' : ''}`}>
                <select 
                    className={props.className}
                    multiple={props.multiple ? props.multiple : false} 
                    onChange={props.multiple ? handleMultiChange : handleChange} 
                    name={props.name} 
                    defaultValue={props.value || ''} 
                    required={props.required}>
                    {
                        !props.multiple &&
                            <option disabled value=""> {props.placeHolder || '...'} </option>
                    }
                    {
                        props.options?.map((opt, index) => {
                            return (
                                <option 
                                    key={index} 
                                    value={opt.value} 
                                    selected={props.value !== undefined ? opt.value === props.value : props.values !== undefined ? props.values.some(elem => elem === opt.value) : false}> 
                                        {opt.name} 
                                </option>
                            )
                        })
                    }
                </select>
            </div>
        </div>
    );
}